import { Component, OnInit, Inject, Optional, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LanguageService } from '../../shared/services/language.service';
import { ProjectTypesService } from '../../shared/services/project-types.service';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { InfoBarWithStatusService } from '../../shared/services/info-bar-with-status.service';
import { UsersManagementService } from '../../shared/services/usersManagement.service';
import { catchError, delay, retryWhen, scan } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 500,
  hideDelay: 500,
  touchendHideDelay: 500,
};

@Component({
  standalone: false,
  selector: 'app-user-dialog',
  templateUrl: './user-dialog.component.html',
  styleUrls: ['./user-dialog.component.css']
})
export class UserDialogComponent implements OnInit {

  variables: any;

  //Temporary static items.
  items: any;

  local_data: any; //local data is the data that has been passed from the parent to this dialog and will be passed back to the parent.

  invalidMail: boolean = false;
  invalidInputUser: boolean = false;

  errorMail: string = '';
  errorMessageUser: string = '';
  errorMessages: any;

  isUsers: boolean = false;
  showMacro: boolean = false;
  filteredMacro: any[] = [];
  emailAlreadyUsed: boolean = false;

  isLoading: boolean = true;
  errorDetected: boolean = false;
  errorText: any;

  formGroup1: any;

  originalEmail: string = '';

  filteredUsers: any[] = [];
  allUsers: any[] = [];

  effort = '';

  otherType = false; //Flag to check if the user will add a custom input or use a predefined type.
  otherTypeMacro = false;

  riskInputEffort: any;

  isActionType: boolean = false;

  listInDB: any;
  isEdit = false;


  constructor(private projectTypesService: ProjectTypesService,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private infoBar: InfoBarWithStatusService,
    private usersManagementService: UsersManagementService,
    private languageService: LanguageService
  ) {
    this.local_data = { ...data };
    this.items = [
      { name: this.variables?.implementation },
      { name: 'Review' },
      { name: this.variables?.other }
    ];
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;

      this.items = [
        { name: this.variables?.implementation },
        { name: 'Review' },
        { name: this.variables?.other }
      ];

      this.effort = this.variables?.hours;
    });

    this.isEdit = this.local_data.isEdit

    if (this.isEdit) this.originalEmail = this.data.item.email;

    //Add default values to predefined list
    let list = this.local_data.list;
    this.listInDB = this.local_data.listInDB;
    this.allUsers = this.local_data.allUsers;
    this.filteredUsers = this.local_data.allUsers;


    //Check to see if the value selected from the predefined list is 'Outro', meaning that the user will add a custom input and the form should be displayed to the user.

    if (this.isEdit && this.local_data.isUsers) {
      this.formGroup1 = this._formBuilder.group({
        firstCtrlUser: [this.local_data.item.name, Validators.required],
        userFilterCtrl: [this.local_data.item.name, Validators.required],
        mailCtrl: [this.local_data.item.email, Validators.required],
      });
    }

    else {
      this.formGroup1 = this._formBuilder.group({
        firstCtrlUser: ['', Validators.required],
        userFilterCtrl: ['', Validators.required],
        mailCtrl: ['', Validators.required],

      });
    }

    if (this.local_data.effort) this.effort = this.local_data.effort;


    this.isUsers = this.local_data.isUsers !== undefined ? this.local_data.isUsers : false;

    this.formGroup1.get('firstCtrlUser')?.valueChanges.subscribe((result: any) => {
      this.otherType = result === this.variables.other;
    });

  }

  filterUsers() {
    if (!this.allUsers) {
      return;
    };

    let search = this.formGroup1.get('userFilterCtrl')?.value?.trim();
    if (!search) {
      this.filteredUsers = (this.allUsers.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredUsers = this.allUsers.filter((user: any) => user.name.toLowerCase().indexOf(search) > -1);
  }

  onChangeUsers(user: any) {

    this.cleanErrors();
    this.formGroup1.get('mailCtrl').setValue(user.email);

  }

  validateUniqueUserName() {
    const nameToValidate = this.formGroup1.get('firstCtrlUser')?.value?.trim();

    return !this.listInDB.some((item: any) =>
      item.name === nameToValidate &&
      (!this.isEdit || item.email !== this.originalEmail)
    );
  }



  validateUniqueUserMail() {
    const emailToValidate = this.formGroup1.get('mailCtrl')?.value?.trim();

    return !this.listInDB.some((item: any) =>
      item.email === emailToValidate &&
      (!this.isEdit || item.email !== this.originalEmail)
    );
  }



  cleanErrors() {
    this.invalidInputUser = false;
    this.invalidMail = false;

    this.errorMessageUser = '';
    this.errorMail = '';
  }



  doAction() {
    const formGroup = this.formGroup1.value;

    let valid = true;
    this.cleanErrors()

    /*
      Check if all the inputs have been filled.
    */
    if (this.isUsers && (formGroup.firstCtrlUser.length <= 0 || !formGroup.firstCtrlUser)) {
      this.invalidInputUser = true;
      this.errorMessageUser = this.variables.mandatoryUserName;
      valid = false;
    }

    if (!this.validateUniqueUserName()) {
      this.invalidInputUser = true;
      this.errorMessageUser = this.variables.alreadyExists;

      valid = false;
    }

    if (!this.validateUniqueUserMail()) {
      this.invalidMail = true;
      this.errorMail = this.variables.alreadyUsedEmail;
      valid = false;
    }

    if (formGroup.firstCtrlUser) {
      this.local_data.userName = formGroup.firstCtrlUser;
    }

    else {
      this.local_data.name = formGroup.secondCtrl;
    }

    if (formGroup.mailCtrl != '') {
      this.local_data.dasID = formGroup.mailCtrl;
    }
    else {
      this.local_data.dasID = this.local_data.allUsers.find((user: any) => user.name === formGroup.firstCtrlUser)?.email || '';
    }



    //Pass data
    if (valid) {
      this.dialogRef.close({ data: this.local_data })
    }
    else {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 2000);

    };
  }


}
